const title = 'Miðstöð hönnunar og arkítektúrs';
// tslint:disable-next-line:max-line-length
const description =
  'Miðstöð hönnunar og arkitektúrs er hreyfiafl sjálfbærrar verðmætasköpunar sem byggir á hönnun og arkitektúr.';

// tslint:disable-next-line: no-var-requires
const favicon = require('assets/images/favicon.png');
// tslint:disable-next-line: no-var-requires
const share = require('assets/images/share.png');

// We need fully qualified url
const domain = process.env.GATSBY_DOMAIN || '';
const shareWithDomain = `${domain}${share}`;

export const helmet = {
  title,
  titleTemplate: '%s – Miðstöð hönnunar og arkitektúrs',
  htmlAttributes: { lang: 'is' },
  meta: [
    { name: 'description', content: description },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, user-scalable=yes',
    },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
    { name: 'msapplication-navbutton-color', content: '#410099' },
    { name: 'msapplication-TileColor', content: '#410099' },
    { name: 'theme-color', content: '#410099' },

    { property: 'og:title', content: title },
    { property: 'og:image', content: shareWithDomain },
    { property: 'og:image:width', content: '1200px' },
    { property: 'og:image:height', content: '640px' },

    { name: 'twitter:title', content: title },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:image', content: shareWithDomain },
    { name: 'twitter:site', content: '@honnunarmidstod' },
    { name: 'twitter:creator', content: '@honnunarmidstod' },
    { name: 'twitter:description', content: description },
  ],
  link: [{ rel: 'icon', type: 'image/x-icon', href: favicon }],
};
